<template>
    <div class="wraper">
        <div v-if="courses == null" id="no-courses">
            <h1 id="study-plan-title">No hay Cursos</h1>
        </div>
        <div v-else>
            <div v-for="course in courses">
                    <view-inprogress :courseId="course"></view-inprogress>
                </div>
           </div>
        </div>
    </div>
</template>

<script>
import viewInprogress from '@/components/courses/myCourses/viewInprogress'
import { getTrainingByPosition } from '@/requests/trainings'
import axios from 'axios'
import { userAPIRoot } from '@/config/users.config'
export default {
    components: { viewInprogress },
    data(){
        return { 
            loading: true,
            courses: null,
        }
    },
    mounted() {

        axios.get(userAPIRoot+'/users/'+this.$session.get('userId')+'/companyUsers')
        .then((respuesta)=>{
            //console.log(respuesta.data)
            getTrainingByPosition({ companyId: respuesta.data[0].company, positionId: respuesta.data[0].position})
            .then((res)=>{
                // console.log(res.items[0].courses)
                if(res.items[0]){
                    this.courses = res.items[0].courses
                }
            })
        })
    }
    
}
</script>

<style scpoed>
    
</style>



// WEBPACK FOOTER //
// src/components/courses/myCourses/inProgress.vue